import axios from "../../utils/axios";
import {setAuthToken} from "../../utils/utils";
import {SET_CURRENT_USER, SET_INVITED_USER} from "./actionTypes";
import {setErrors} from "./error";
import {setErrors as setError} from "./user";
import {toast} from 'react-toastify';
import {setInvitedAdmin} from "./warehouse";

// Login
export const login = (userData, history) => dispatch => {
  axios
      .post('auth-users/login/', userData)
      .then(response => {
        // Save to localStorage
        const {token} = response.data;
        localStorage.setItem('token', token);
        localStorage.setItem('user', btoa(JSON.stringify(response.data)));
        // Set token to Auth header
        setAuthToken(token);
        // Set current user
        dispatch(setCurrentUser(response.data));
        history.push('/dashboard');
      })
      .catch(error => dispatch(setErrors(error.response)));
};

// Set logged in user
export const setCurrentUser = user => ({
  type: SET_CURRENT_USER,
  payload: user
});

// Log user out
export const logout = () => dispatch => {
  // Remove token from localStorage
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  // Remove auth header
  setAuthToken(false);
  // Set current user to {}
  dispatch(setCurrentUser({}));
};

export const forgotPassword = (email, history) => () => {
  axios
      .post('auth-users/forgot-password/', {email})
      .then(() => {
        toast.success('The password reset email is sent successfully. Please check your inbox for further instructions.', {
          position: toast.POSITION.TOP_RIGHT,
          className: ''
        });
        history.push('/login');
      })
      .catch(console.log);
};

export const resetPassword = (resetKey, data, history) => dispatch => {
  axios
      .post(`auth-users/reset-password/${resetKey}/`, data)
      .then(response => {
        const {token} = response.data;
        localStorage.setItem('token', token);
        localStorage.setItem('user', btoa(JSON.stringify(response.data)));
        dispatch(setCurrentUser(response.data));
        history.push('/dashboard');
      })
      .catch(() => toast.error('Invalid Token.', {
        position: toast.POSITION.TOP_RIGHT,
        className: ''
      }));
};

export const checkUniqueEmail = body => dispatch => {
  axios
      .post('check-email/', {email: body.email})
      .then(() => dispatch(setInvitedAdmin(body)))
      .catch(error => dispatch(setError(error.response)));
};

export const getInvitedUser = token => dispatch => {
  axios
      .post(`accept-invitations/${token}/`)
      .then(response => dispatch(setInvitedUser(response.data)))
      .catch(() => toast
          .error('Invalid token.', {
            position: toast.POSITION.TOP_RIGHT,
            className: ''
          }));
};

const setInvitedUser = user => ({
  type: SET_INVITED_USER,
  payload: user
});

export const register = (passwordData, userData, history) => dispatch => {
  axios
      .post('auth-users/register/', passwordData)
      .then(() => {
        dispatch(setCurrentUser(userData));
        history.push('/dashboard');
      })
      .catch(console.log);
};


// WEBPACK FOOTER //
// ./src/store/actions/auth.js